import { Link } from "react-router-dom";
import { Smartphone, Laptop, Tablet, Watch, MapPin, Phone, Mail, Clock } from "lucide-react";

const LogoSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 56" fill="none" className="h-8">
    <circle cx="28" cy="28" r="27.5" fill="#FF5C00" opacity="0.05"/>
    <rect x="26" y="0.5" width="4" height="4.5" rx="0.8" fill="#383840"/>
    <rect x="40" y="3.5" width="4" height="4.5" rx="0.8" fill="#383840" transform="rotate(45 42 5.75)"/>
    <rect x="49.5" y="26" width="4.5" height="4" rx="0.8" fill="#383840"/>
    <rect x="43" y="43.5" width="4" height="4.5" rx="0.8" fill="#383840" transform="rotate(-45 45 45.75)"/>
    <rect x="26" y="51" width="4" height="4.5" rx="0.8" fill="#383840"/>
    <rect x="10" y="43.5" width="4" height="4.5" rx="0.8" fill="#383840" transform="rotate(45 12 45.75)"/>
    <rect x="2" y="26" width="4.5" height="4" rx="0.8" fill="#383840"/>
    <rect x="10" y="3.5" width="4" height="4.5" rx="0.8" fill="#383840" transform="rotate(-45 12 5.75)"/>
    <line x1="46" y1="12" x2="49.5" y2="9" stroke="#383840" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="10" y1="12" x2="6.5" y2="9" stroke="#383840" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="46" y1="44" x2="49.5" y2="47" stroke="#383840" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="10" y1="44" x2="6.5" y2="47" stroke="#383840" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="28" cy="28" r="22.5" stroke="#252528" strokeWidth="6" fill="none"/>
    <circle cx="28" cy="28" r="19.5" stroke="rgba(255,255,255,0.07)" strokeWidth="0.5" fill="none"/>
    <circle cx="28" cy="28" r="19" fill="#FF5C00"/>
    <line x1="18" y1="9.5" x2="18" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="21.5" y1="9.5" x2="21.5" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="25" y1="9.5" x2="25" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="28.5" y1="9.5" x2="28.5" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="32" y1="9.5" x2="32" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="35.5" y1="9.5" x2="35.5" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <line x1="39" y1="9.5" x2="39" y2="46.5" stroke="#000" strokeWidth="1.5" opacity="0.13"/>
    <g transform="translate(13, 10) scale(0.8)" fill="#000" opacity="0.32">
      <path d="M28.6 22.3c0-4.5 3.8-7.3 3.9-7.4-2.1-3-5.3-3.5-6.5-3.5-2.8-.3-5.4 1.6-6.8 1.6-1.4 0-3.6-1.5-5.9-1.5-3 0-5.8 1.8-7.3 4.4-3.1 5.3-.8 13.2 2.2 17.5 1.5 2.1 3.2 4.4 5.5 4.3 2.2-.1 3-1.4 5.7-1.4 2.6 0 3.4 1.4 5.7 1.4 2.3 0 3.8-2.1 5.2-4.2 1.7-2.4 2.4-4.8 2.5-4.9-.1-.1-4.2-1.6-4.2-6.3zm-3.6-10.1c1.2-1.5 2.1-3.6 1.8-5.6-1.8.1-4 1.2-5.2 2.7-1.1 1.3-2.1 3.4-1.9 5.4 2 .2 3.9-.9 5.3-2.5z"/>
    </g>
    <text x="62" y="37" fontFamily="Cabinet Grotesk, sans-serif" fontSize="22" fontWeight="800" fill="#F5F5F7" letterSpacing="-0.5">Atelier du <tspan fill="#FF5C00">Mac</tspan></text>
  </svg>
);

const repairLinks = [
  { icon: Smartphone, label: "iPhone", path: "/reparation/iphone" },
  { icon: Laptop, label: "Mac", path: "/reparation/mac" },
  { icon: Tablet, label: "iPad", path: "/reparation/ipad" },
  { icon: Watch, label: "Apple Watch", path: "/reparation/apple-watch" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0C] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/">
              <img src="/logo-atelierdumac.png" alt="Atelier du Mac" className="h-10 w-auto object-contain" style={{ maxWidth: '180px', filter: 'brightness(0.95)' }} />
            </Link>
            <p className="mt-4 text-sm text-white/50 leading-relaxed">
              Spécialiste de la réparation Apple à Paris. Techniciens certifiés, pièces de qualité, intervention rapide.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#34C759] animate-pulse" />
              <span className="text-sm text-white/50">Ouvert — Lun–Sam 11h–20h</span>
            </div>
          </div>

          {/* Réparations */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">Réparation</h4>
            <ul className="space-y-3">
              {repairLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors"
                    data-testid={`footer-link-${item.label.toLowerCase()}`}
                  >
                    <item.icon className="w-4 h-4 text-[#FF5C00]" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">Services</h4>
            <ul className="space-y-3">
              {[
                { label: "Accessoires", path: "/accessoires" },
                { label: "Devis en ligne", path: "/devis" },
                { label: "Prise de RDV", path: "/contact" },
                { label: "Nos ateliers", path: "/nos-magasins" },
                { label: "Contact", path: "/contact" },
              ].map((item) => (
                <li key={item.path + item.label}>
                  <Link to={item.path} className="text-sm text-white/60 hover:text-white transition-colors" data-testid={`footer-link-${item.label.toLowerCase().replace(/\s/g, '-')}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#FF5C00] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-white/60">9 Rue de Mont-Louis<br />75011 Paris</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#FF5C00] flex-shrink-0" />
                <a href="tel:+33611367002" className="text-sm text-white/60 hover:text-white transition-colors">06 11 36 70 02</a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#FF5C00] flex-shrink-0" />
                <span className="text-sm text-white/60">Lun–Sam : 11h–20h</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#FF5C00] flex-shrink-0" />
                <a href="mailto:contact@atelierdumac.fr" className="text-sm text-white/60 hover:text-white transition-colors">
                  contact@atelierdumac.fr
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">© 2026 Atelier du Mac. Tous droits réservés.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">Mentions légales</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">CGV</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
